import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment.local';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ProcedureIdResponse, ProcedurePostResponse, ProcedureResponse} from '../../models/procedures/ProcedureResponse';
import {ProcedureBody} from '../../models/procedures/ProcedureBody';

@Injectable({
  providedIn: 'root'
})
export class ProceduresService {
  private apiUrl = `${environment.apiUrl}/procedures`;

  constructor(private http: HttpClient) { }

  getProcedures(params?: any): Observable<ProcedureResponse> {
    return this.http.get<ProcedureResponse>(this.apiUrl, {params});
  }

  getProcedureById(id: string): Observable<ProcedureIdResponse> {
    return this.http.get<ProcedureIdResponse>(`${this.apiUrl}/${id}`);
  }

  postProcedure(procedureBody: ProcedureBody): Observable<ProcedurePostResponse> {
    return this.http.post<ProcedurePostResponse>(this.apiUrl, procedureBody);
  }

  updateProcedure(id: string, procedureBody: ProcedureBody): Observable<ProcedurePostResponse> {
    return this.http.put<ProcedurePostResponse>(`${this.apiUrl}/${id}`, procedureBody);
  }

  deleteProcedure(id: string): Observable<ProcedurePostResponse> {
    return this.http.delete<ProcedurePostResponse>(`${this.apiUrl}/${id}`);
  }
  generatePdf(id: string, logigrammeHtml: string, logigrammeHeight: number, logigrammeWidth: number): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/pdf/${id}`, {logigrammeHtml, logigrammeWidth, logigrammeHeight});
  }

}
